<div class="rolling-page">
    <div class="content">
        <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
        <h2>{{ _translateService.Keys.ROLLING_TITLE | translate }}</h2>
        <p>{{ _translateService.Keys.ROLLING_MESSAGE | translate }}</p>
        <button [routerLink]="['/verification']" class="primary-button">
            {{ _translateService.Keys.COMMON_CONTINUE | translate }}
        </button>
    </div>
</div>